var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewSearchicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43812_9210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14844 1.80469C11.4604 1.80469 14.1484 4.49269 14.1484 7.80469C14.1484 11.1167 11.4604 13.8047 8.14844 13.8047C4.83644 13.8047 2.14844 11.1167 2.14844 7.80469C2.14844 4.49269 4.83644 1.80469 8.14844 1.80469ZM8.14844 12.4714C10.7264 12.4714 12.8151 10.3827 12.8151 7.80469C12.8151 5.22602 10.7264 3.13802 8.14844 3.13802C5.56977 3.13802 3.48177 5.22602 3.48177 7.80469C3.48177 10.3827 5.56977 12.4714 8.14844 12.4714ZM13.8051 12.5187L15.6911 14.404L14.7478 15.3474L12.8624 13.4614L13.8051 12.5187Z",
    fill: "#67768E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43812_9210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.8125 0.46875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSearchicon);
export default __webpack_public_path__ + "static/media/newSearchicon.509611806578b6d4760a8ad38f9105f1.svg";
export { ForwardRef as ReactComponent };